import { ChartColumn } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "src/components/Default/Main/Box";
import {
	Modal,
	ModalHeader,
} from "src/components/Modals/Components/ModalsComponents";
import { ExamCategoriesStats } from "src/components/Modals/StatisticsModals/ExamCategoriesStats";
import { ExamInfoStats } from "src/components/Modals/StatisticsModals/ExamInfoStats";
import type { ExamStats } from "src/components/Modals/StatisticsModals/examStatsTypes";
import { useGetExamStats } from "src/hooks/useExam";

interface ExamStatisticsModalProps {
	examId: string;
	onClose: () => void;
}

const TABS = {
	EXAM_INFO: 0,
	CATEGORIES: 1,
} as const;

export const ExamStatisticsModal = ({
	examId,
	onClose,
}: ExamStatisticsModalProps) => {
	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState<number>(TABS.EXAM_INFO);
	const { data: stats, isLoading } = useGetExamStats(examId) as {
		data?: ExamStats;
		isLoading: boolean;
	};

	return (
		<Modal onClose={onClose} isLoading={isLoading} maxWidth="sm">
			<div data-test-id="exam-statistics-modal">
				<ModalHeader
					Icon={ChartColumn}
					title={t("modals.statistics.title", "Statystyki")}
					hasCloseButton
				/>
				<Box
					className="border-none box-shadow-none p-0 mt-24"
					headerClassName="mb-0 border-bottom-1 pb-12"
					tabs={[
						t("modals.statistics.tabs.examInfo", "Dane egzaminu"),
						t("modals.statistics.tabs.stats", "Statystyki"),
					]}
					selectedTab={selectedTab}
					onTabsChange={setSelectedTab}
					tabTestIds={["exam-stats-tab-info", "exam-stats-tab-categories"]}
				/>
				{stats &&
					(selectedTab === TABS.EXAM_INFO ? (
						<ExamInfoStats stats={stats} />
					) : (
						<ExamCategoriesStats departments={stats.departmentsStats ?? []} />
					))}
			</div>
		</Modal>
	);
};
